/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AddressGetCitiesRequest = {
  properties: {
    stateIds: {
      type: 'array',
      contains: {
        type: 'string',
      },
      isRequired: true,
    },
  },
} as const;
